// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from edit.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function EditIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd" fill="none">
        <path d="M0 0h16v16H0z" />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m11 4 1 1-9 9-2 1 1-2 9-9zm3-3 1 1-1 1-1-1 1-1z"
        />
      </g>
    </svg>
  );
}
